import markerIconGrayV2 from "@assets/images/icons/icon_marker_gray.png";
import markerIconGreenV2 from "@assets/images/icons/icon_marker_green.png";
import markerIconYellowV2 from "@assets/images/icons/icon_marker_yellow.png";
import { E_ProcessClaimedStatus } from "@src/types";

export interface IMap {
  process_position_b2c: number;
  process_long: string;
  process_lat: string;
  process_name: string;
  b2c_url?: string;
  process_id?: string;
  process_status?: number;
  claimed_status?: E_ProcessClaimedStatus;
  process_manufacturer_name?: string;
  custom_date?: string;
  status?: number;
  connected_orders?: any[];
}

export interface MarkerInfo {
  process_lat: string;
  process_long: string;
}

export interface MapMarkersInfo {
  markers: MarkerInfo[];
  center: MapCenter;
  zoomLevel: number;
  maxDistance?: number;
}

export interface ProcessData {
  process_position_b2c: number;
  process_lat: string;
  process_long: string;
  process_name: string;
  process_id?: string;
  process_manufacturer_name?: string;
  b2c_url?: string;
  claimed_status?: E_ProcessClaimedStatus;
  process_status?: number;
  custom_date?: string;
  status?: number;
  latitude?: string;
  longitude?: string;
  id?: string;
  custom_order?: string;
  list?: ProcessData[];
  connected_orders?: any[];
  name?: string;
}

export interface I_POS {
  poz: {
    claimed_status?: E_ProcessClaimedStatus;
    custom_order?: string;
    process_name?: string;
    process_manufacturer_name?: string;
    fibretrace_id_label?: string;
    scanner?: {
      name: string;
    };
  };
  onClickProcess?: () => void
}

export interface VerifiedLabelMarkupProps {
  className?: string;
  poz: {
    claimed_status?: E_ProcessClaimedStatus;
    scanner?: {
      name: string;
    };
  };
}

export interface MapCenter {
  lat: number;
  lng: number;
}

export interface MarkerOptions {
  position: google.maps.LatLng | google.maps.LatLngLiteral;
  icon?: google.maps.Icon | google.maps.Symbol;
  label?: google.maps.MarkerLabel;
  zIndex?: number;
  onMouseOver?: () => void;
  onMouseOut?: () => void;
  onClick?: () => void;
}

export interface POSMapProps {
  data: IMap[];
}

export const ProcessStatusMap = {
  [E_ProcessClaimedStatus.UNCLAIMED]: {
    imgSource: markerIconYellowV2,
    imgAlt: "Unclaimed",
  },
  [E_ProcessClaimedStatus.SELF_REPORTED]: {
    imgSource: markerIconYellowV2,
    imgAlt: "Unclaimed",
  },
  [E_ProcessClaimedStatus.CLAIMED]: {
    imgSource: markerIconGrayV2,
    imgAlt: "Claimed",
  },
  [E_ProcessClaimedStatus.VERIFIED]: {
    imgSource: markerIconGreenV2,
    imgAlt: "Verified",
  },
};